import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientPositionDto } from './models/client-position.dto';

@Injectable({ providedIn: 'root' })
export class ClientPositionPickerProvider {
  constructor(private http: HttpClient) {}

  // the order bank: open positions across all zamówienia, narrowed by name, number or client
  searchClientPositions(search: string): Observable<ClientPositionDto[]> {
    const url = `/api/client-orders/positions`;
    return this.http.get<ClientPositionDto[]>(url, {
      params: { search }
    });
  }
}
